import React, { useState } from 'react';
import { cn } from '../../lib/utils';

function GalleryImage({ item }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <figure className="relative mb-3 break-inside-avoid overflow-hidden rounded-2xl border border-slate-200 bg-slate-100">
      {!loaded && <div className="absolute inset-0 animate-pulse bg-slate-200" />}
      <img
        src={item.img}
        alt={item.title}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={cn(
          'w-full object-cover transition-opacity duration-500',
          loaded ? 'opacity-100' : 'opacity-0'
        )}
      />
      <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3">
        <span className="font-heading text-sm font-semibold text-white">{item.title}</span>
      </figcaption>
    </figure>
  );
}

export default function GalleryGrid({ items }) {
  return (
    <div className="columns-2 gap-3 md:columns-3 xl:columns-4" data-testid="gallery-grid">
      {items.map((item) => (
        <GalleryImage key={item.id} item={item} />
      ))}
    </div>
  );
}


